const websiteVersion = process.env.NODE_ENV === 'development' ? '' : 'dbe9763'

export default websiteVersion
